import React from 'react'

import { AppSvg, Button, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import s from './s.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'

interface Props {
    onClose: () => void
    currency: string
}

function Content({ onClose, currency }: Props) {
    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80Info} size={80} path="new-icons" />
                </div>
            }
            title={
                <FormattedHTMLMessage
                    {...(currency ? lang.currencyTitle : lang.title)}
                    values={{ currency: currency?.toUpperCase() }}
                />
            }
            contentClassName={s.hack}
        >
            <Button mode="primary" dataPointer="cancel" size="l" onClick={onClose} fullWidth>
                <FormattedHTMLMessage {...lang.ok} />
            </Button>
        </ModalView>
    )
}

export default Content
